import Vue from "vue";

import url from "./url";
Vue.filter("url", url);

import currency from "./currency";
Vue.filter("currency", currency);
